import { useBackgroundQuery, type QueryRef } from '@apollo/client/react';
import { useMemo } from 'react';

import { QueryOrderEnum, EscrowMembershipsOrderByEnum } from 'src/graphql/schema';
import {
  EscrowMembershipsDocument,
  type IEscrowMembershipsQuery,
} from 'src/graphql/actions/escrowMemberships/escrowMemberships.query';
import { createRequiredContext } from 'src/context/createRequiredContext';

const [useMembershipsManagement, MembershipsManagementProvider] = createRequiredContext<{
  addSuccessCallback?: () => void;
  removeSuccessCallback?: () => void;
  queryEscrowMembershipsRef: QueryRef<IEscrowMembershipsQuery>;
  beneficiaryId: string;
  canCreateMember: boolean;
}>();

type Props = {
  beneficiaryId: string;
  canCreateMember: boolean;
  addSuccessCallback?: () => void;
  removeSuccessCallback?: () => void;
};

const MembershipsManagementContextProvider = ({
  children,
  beneficiaryId,
  canCreateMember,
  addSuccessCallback,
  removeSuccessCallback,
}: React.PropsWithChildren<Props>) => {
  const [queryRef] = useBackgroundQuery(EscrowMembershipsDocument, {
    variables: {
      beneficiaryId,
      page: 1,
      perPage: 100,
      orderBy: EscrowMembershipsOrderByEnum.Role,
      order: QueryOrderEnum.Asc,
    },
  });

  const queryEscrowMembershipsRef = useMemo(() => queryRef, [queryRef]);

  const values = {
    beneficiaryId,
    canCreateMember,
    addSuccessCallback,
    removeSuccessCallback,
    queryEscrowMembershipsRef,
  };

  return <MembershipsManagementProvider value={values}>{children}</MembershipsManagementProvider>;
};

export { MembershipsManagementContextProvider, useMembershipsManagement };
